import {
  ILoadingMessageRecipient,
  IMessageReciept,
  IMessageRecieptRecipient,
  SendMessageStateEnum,
} from 'shared/models/Message'
import { ISendEmailState, ISendSmsState } from './SendMessage'

const initialState = {
  message: null,
  messageId: null as string | null,
  state: null as SendMessageStateEnum | null,
  loading: false,
  processing: false,
  isDraftUpdated: false,
  isEditDraft: false,
  isCollapsed: false,
  error: null as string | null,
  reciept: {
    data: null as IMessageReciept | null,
    loading: false,
    processing: false,
    createContact: null as IMessageRecieptRecipient | null,
    error: null as string | null,
    messageId: null as string | null,
  },
  recipientLoadingQueue: [] as ILoadingMessageRecipient[],
}

export const initialSendEmailState: ISendEmailState = {
  ...initialState,
  savingAttachments: false,
}

export const initialSendSmsState: ISendSmsState = initialState
